import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationExtras,
  Params,
} from '@angular/router';

import * as $ from 'jquery';
import * as HttpStatus from 'http-status-codes';

import { LoginForm } from '../login/login-form';

import { MainService } from '../../services/main.service';
import { UsersService } from '../../services/users.service';
import { BookingsService } from '../../services/bookings.service';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  API = this.helper.getApi();
  modelLogin = new LoginForm('', '');
  notification = { message: '', type: '' };
  submitted = false;
  currentUser: any;
  clinics = '';
  token: string;
  tokenExpired = true;
  tokenText = 'Loading...';
  preselectedClinic: string;
  superClinicId: string;
  service: string;
  type: string;
  loading = false;
  singleClinic: string;
  cprToken: string;
  cprLoading: boolean = false;
  user = this.helper.getStorage('currentUser');
  readonly clinicType = Constants.CLINIC_TYPE;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    public mainService: MainService,
    private usersService: UsersService,
    private bookingsService: BookingsService
  ) {}

  ngOnInit() {
    const url = this.router.url;
    const url_string = 'clinics%3D';

    if (url.includes(url_string)) {
      this.clinics = url.slice(url.indexOf(url_string) + url_string.length);
    }

    if (this.user) {
      localStorage.clear();
    }

    this.route.queryParams.subscribe((params: Params) => {
      this.token = params.bookingToken;
      this.preselectedClinic = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.type = params.type;
      this.singleClinic = params.singleClinic;
      this.cprToken = params.cprToken;

      if (this.token) {
        this.loginToken()
          .then(() => {
            let navigationExtras: NavigationExtras = {
              queryParams: {
                service: this.service,
                type: this.type ? this.type : 'fysiq',
                singleClinic: this.preselectedClinic ? true : false,
                clinics: this.preselectedClinic,
                superClinicId: this.superClinicId,
              },
            };

            this.router.navigate(['/welcome'], navigationExtras);
          })
          .catch((err) => {
            setTimeout(() => {
              this.tokenExpired = true;
              this.tokenText = 'Token expired';
            }, 2000);
          });
      }

      if (this.cprToken) {
        this.loginCpr(this.cprToken);
      }
    });
  }

  loginCpr(cprToken) {
    this.cprLoading = true;

    const loginData = {
      token: cprToken,
    };

    this.usersService
      .loginWithCpr(loginData)
      .subscribe(this.handleLoginCprSuccess.bind(this));
  }

  handleLoginCprSuccess(loginResponse) {
    if (loginResponse.status === HttpStatus.OK) {
      localStorage.setItem('currentUser', JSON.stringify(loginResponse.response));

      this.bookingsService
        .getBookings(null, this.clinicType.custom)
        .subscribe((bookingsResponse) => {
          this.handleCprBookings(bookingsResponse);
        });
    } else {

      if (loginResponse.cpr) {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            bookingToken: this.token,
            service: this.service,
            type: this.type ? this.type : 'fysiq',
            singleClinic: this.preselectedClinic ? true : false,
            clinics: this.preselectedClinic,
            superClinicId: this.superClinicId,
            cpr: loginResponse.cpr
          },
        };

        this.router.navigate(['/signup'], navigationExtras);
      }
      
      this.modelLogin.cprNr = loginResponse.cpr ? loginResponse.cpr : '';
      
    };
  }

  handleCprBookings(bookingsResponse) {
    if (bookingsResponse.status === HttpStatus.OK) {
      const bookings = bookingsResponse.response;

      if (bookings.length > 0) {

        bookings.map((booking) => {

          if (booking.comment) {
            try {
              booking.comment = JSON.parse(booking.comment);  
            } catch (error) {
              
            }
          }
        });

        let lastBooking = this.lastBooking(bookings);

        this.storeCprTherapistData(lastBooking, bookings);
      } else {
        localStorage.setItem('bookings', JSON.stringify([]));

        this.goToWelcome();
      }
    }
  }

  goToWelcome() {
    this.mainService.getClinics().subscribe(() => {
      this.setupUrl('welcome');
    });
  }

  storeCprTherapistData(lastBooking, bookings) {
    if (lastBooking) {
      this.mainService
        .getTherapists(lastBooking.clinic, null)
        .subscribe((therapistsResponse) => {
          const therapists = therapistsResponse.response;

          lastBooking.therapistData = therapists.filter(
            (therapist) =>
              lastBooking.therapist.toLowerCase() === therapist.id.toLowerCase()
          )[0];

          localStorage.setItem('bookings', JSON.stringify(bookings));

          this.goToWelcome();
        });
    } else {
      localStorage.setItem('bookings', JSON.stringify(bookings));

      this.goToWelcome();
    }
  }

  loginToken() {
    const list = { token: decodeURIComponent(this.token) };

    return new Promise((resolve, reject) => {
      this.usersService.login(list).subscribe(
        (loginResponse) => {
          if (loginResponse.status === HttpStatus.OK) {
            this.mainService
              .getTherapists(null, this.clinicType.custom)
              .subscribe(() => {
                this.bookingsService
                  .getBookings(null, this.clinicType.custom)
                  .subscribe(() => {
                    this.mainService.getClinics().subscribe((clinics) => {
                      this.handleTokenSuccess();

                      resolve();
                    });
                  });
              });
          } else {
            this.redirectTokenRegister(loginResponse);
          }
        },
        (error) => {
          reject(error);

          let navigationExtras: NavigationExtras = {
            queryParams: {
              bookingToken: this.token,
              clinics: this.preselectedClinic,
              superClinicId: this.superClinicId,
              service: this.service,
              type: this.type ? this.type : 'fysiq',
              singleClinic: this.preselectedClinic ? true : false,
            },
          };

          this.router.navigate(['/signup'], navigationExtras);
        }
      );
    });
  }

  redirectTokenRegister(loginResponse) {
    const details = {
      cprNr: loginResponse.profile.cpr,
      lastName: loginResponse.profile.efternavn,
      email: loginResponse.profile.email,
      cellNr: loginResponse.profile.telefon,
      firstName: loginResponse.profile.fornavn,
    };

    localStorage.setItem('signup_details', JSON.stringify(details));

    let navigationExtras: NavigationExtras = {
      queryParams: {
        bookingToken: this.token,
        service: this.service,
        type: this.type ? this.type : 'fysiq',
        singleClinic: this.preselectedClinic ? true : false,
        clinics: this.preselectedClinic,
        superClinicId: this.superClinicId,
      },
    };

    this.router.navigate(['/signup'], navigationExtras);
  }

  handleTokenSuccess() {
    this.currentUser = this.helper.getStorage('currentUser');

    let params = {
      service: this.service,
      type: this.type ? this.type : 'fysiq',
      singleClinic: this.preselectedClinic ? true : false,
      clinics: this.preselectedClinic,
      superClinicId: this.superClinicId,
    };

    this.checkEmailCpr(params);
  }

  login(type, data, urlParams) {
    let details;

    if (type === 'register') {
      details = data;
    } else {
      let cpr = $('#cpr').val();

      if (cpr) {
        cpr = cpr.replace('-', '');
      }

      details = {
        email: cpr,
        password: $('#password').val(),
      };
    }

    this.loading = true;

    this.usersService.login(details).subscribe((loginResponse) => {
      if (loginResponse.status === HttpStatus.OK) {
        this.bookingsService
          .getBookings(null, this.clinicType.custom)
          .subscribe((bookingsResponse) => {
            this.handleBookings(bookingsResponse, type, urlParams);
          });
      } else {
        this.notification = { message: 'Login Mislykkedes', type: 'error' };
        this.loading = false;
      }
    });
  }

  handleBookings(bookingsResponse, type, urlParams) {
    if (bookingsResponse.status === HttpStatus.OK) {
      const bookings = bookingsResponse.response;

      if (bookings.length > 0) {
        bookings.map((booking) => {

          if (booking.comment) {
            try {
              booking.comment = JSON.parse(booking.comment);  
            } catch (error) {
              
            }
          }
        });
        
        let lastBooking = this.lastBooking(bookings);

        this.storeTherapistData(lastBooking, type, urlParams, bookings);
      } else {
        localStorage.setItem('bookings', JSON.stringify([]));

        this.handleClinics(type, urlParams);
      }
    }
  }

  storeTherapistData(lastBooking, type, urlParams, bookings) {
    if (lastBooking) {
      this.mainService
        .getTherapists(lastBooking.clinic, null)
        .subscribe((therapistsResponse) => {
          const therapists = therapistsResponse.response;

          lastBooking.therapistData = therapists.filter(
            (therapist) =>
              lastBooking.therapist.toLowerCase() === therapist.id.toLowerCase()
          )[0];

          localStorage.setItem('bookings', JSON.stringify(bookings));

          this.handleClinics(type, urlParams);
        });
    } else {
      localStorage.setItem('bookings', JSON.stringify(bookings));

      this.handleClinics(type, urlParams);
    }
  }

  lastBooking(bookings) {
    let lastBooking = bookings[bookings.length - 1];

    this.route.queryParams.subscribe((params: Params) => {
      if (params.clinics) {
        const singleBookings = bookings.filter(
          (booking) => booking.clinic === params.clinics
        );

        if (singleBookings.length > 0) {
          lastBooking = singleBookings[singleBookings.length - 1];
        }
      }
    });

    return lastBooking;
  }

  handleClinics(type, urlParams) {
    this.mainService.getClinics().subscribe((clinicResponse) => {
      this.handleLoginSuccess(clinicResponse, type, urlParams);
    });
  }

  handleLoginSuccess(clinicResponse, type, urlParams) {
    this.usersService.onSetLoggedIn.emit();

    const isLoggedIn = this.helper.isLoggedIn();

    this.currentUser = this.helper.getStorage('currentUser');

    if (isLoggedIn) {
      this.checkLoginTypes(type, urlParams);

      this.checkClinics();
      this.loading = false;
    } else {
      this.notification = {
        message: 'Login Mislykkedes',
        type: 'error',
      };
      this.loading = false;
    }
  }

  checkClinics(){
    const data = {
      cpr: this.currentUser.data.CPRNumber
    };

    const req = this.usersService.checkClinics(data).subscribe();
  }

  checkLoginTypes(type, urlParams) {
    let params;

    if (type === 'register') {
      params = urlParams;
    } else {
      params = {
        clinics: this.preselectedClinic,
        superClinicId: this.superClinicId,
        service: this.service,
        type: this.type ? this.type : 'fysiq',
        singleClinic: this.preselectedClinic ? true : false,
      };
    }

    this.checkEmailCpr(params);
  }

  setupUrl(url) {
    const params = {
      type: this.type ? this.type : 'fysiq',
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.preselectedClinic) {
      params['clinics'] = this.preselectedClinic;
      params['singleClinic'] = 'true';
    }

    // if fysiq flow, don't send service
    if (url === '/offer-fysiq') {
      params['service'] = null;
    }

    // if single clinic flow, pass clinics param to signup and forgot password
    if (url === '/forgot-password' || url === '/signup') {
      if (this.preselectedClinic) {
        params['clinics'] = this.preselectedClinic;
      }
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate([url], navigationExtras);
  }

  checkEmailCpr(params) {
    if (this.currentUser.data.email && this.currentUser.data.CPRNumber) {
      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      this.usersService.onSetLoggedIn.emit();

      this.router.navigate(['/welcome'], navigationExtras);
    } else {
      if (
        this.currentUser.data.CPRNumber === undefined ||
        !this.currentUser.data.CPRNumber
      ) {
        params['noCpr'] = true;
      }

      if (
        this.currentUser.data.email === undefined ||
        !this.currentUser.data.email
      ) {
        params['noEmail'] = true;
      }

      const navigationExtras: NavigationExtras = {
        queryParams: params,
      };

      this.router.navigate(['/profile'], navigationExtras);
    }
  }

  goToRegister() {
    this.setupUrl('/signup');
  }

  goToForgot() {
    this.setupUrl('/forgot-password');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts